/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
import connector from '../connector';

const addWeeklyMethanes = (data) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('weeklyMethane', 'readwrite');
        const weeklyMethaneStore = transaction.objectStore('weeklyMethane');

        weeklyMethaneStore.clear(); // delete all of the previously added data to add the new list

        data.forEach(singleData => {
            weeklyMethaneStore.add(singleData);
        });

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getWeeklyMethaneByFarmId = (farmId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('weeklyMethane', 'readonly');
        const weeklyMethaneStore = transaction.objectStore('weeklyMethane');
        const farmIdIndex = weeklyMethaneStore.index('FarmIdIndex');

        const farmWeeklyMethane = farmIdIndex.get(farmId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: farmWeeklyMethane.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const getWeeklyMethaneByAnimalId = (animalId) => new Promise(async (resolve, reject) => {
    try {
        const db = await connector();
        const transaction = db.transaction('weeklyMethane', 'readonly');
        const weeklyMethaneStore = transaction.objectStore('weeklyMethane');
        const animalIdIndex = weeklyMethaneStore.index('AnimalIdIndex');

        const animalWeeklyMethane = animalIdIndex.get(animalId);

        transaction.oncomplete = () => {
            db.close();
            resolve({ success: true, data: animalWeeklyMethane.result });
        };
    }
    catch (error) {
        reject({ success: false, error });
    }
});

const weeklyMethane = {
    addWeeklyMethanes,
    getWeeklyMethaneByFarmId,
    getWeeklyMethaneByAnimalId
}

export default weeklyMethane;
